import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Solutions", href: "/#solutions" },
  { label: "Tarifs", href: "/#tarifs" },
  { label: "Blog", href: "/blog", route: true },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background/70 backdrop-blur-2xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-baseline gap-2">
          <span className="font-heading font-black text-xl tracking-tighter">
            GMP<span className="text-accent">.</span>
          </span>
          <span className="font-heading font-medium text-sm tracking-tight text-foreground/80">
            Développement
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) =>
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                data-testid="nav-link-blog"
                className="text-sm text-muted-foreground hover:text-warm transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {l.label}
              </a>
            )
          )}
          <Link
            to="/contact"
            data-testid="navbar-cta"
            className="bg-accent text-background font-semibold text-sm px-5 py-2.5 hover:bg-accent-hover transition-colors"
          >
            Prendre contact
          </Link>
        </nav>

        <button
          className="md:hidden text-foreground"
          onClick={() => setOpen((v) => !v)}
          data-testid="navbar-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background/95 backdrop-blur-2xl border-b border-white/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) =>
            l.route ? (
              <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className="text-base text-muted-foreground hover:text-warm">
                {l.label}
              </Link>
            ) : (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base text-muted-foreground hover:text-foreground">
                {l.label}
              </a>
            )
          )}
          <Link to="/contact" onClick={() => setOpen(false)} className="bg-accent text-background font-semibold text-center px-5 py-3">
            Prendre contact
          </Link>
        </div>
      )}
    </header>
  );
};
